import React from 'react'

import { StyledTimestamp } from '../Byline.styled'
import {
    TimestampLabel,
    TimestampFormat,
} from '../../../typography/Timestamp/Timestamp'
import { Product } from '@news-mono/web-common'
import { useProduct } from '../../../__product/useProduct'
interface BylineTimestampProps {
    timestamp: string | undefined
    timestampLabel?: TimestampLabel
    timestampFormat?: TimestampFormat
}

export const BylineTimestamp: React.FC<BylineTimestampProps> = ({
    timestamp,
    timestampLabel,
    timestampFormat,
}) => {
    const product = useProduct()

    if (!timestamp) {
        return null
    }

    const isSevenNews = product === Product.SevenNews

    return (
        <StyledTimestamp
            iconVisible={isSevenNews}
            timestamp={timestamp}
            timestampFormat={timestampFormat}
            timestampLabel={timestampLabel}
        />
    )
}
